<template>
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "guestCard"
    }
</script>

<style scoped>
  .card_shadow {
    width: 80vw;
    /*padding: 30px;*/
    box-shadow: 0 0 5px 4px rgba(0,0,0,0.04);
    border-radius: 5px;
  }
</style>